import { useSelector } from 'hooks/utils';

export function useEditableTemplatesIds() {
	return useSelector(state => state.data.templates.editableTemplatesIds);
}
